import { Button } from "components/elements";
import {
  Section,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableNoResults,
} from "components/layout";
import { RestrictedArea, ROLES } from "containers/Permissions";
import { pathToUrl } from "utils/url";

import { TiVoAppSubRow } from "../../_shared";
import { PATHS } from "../../constants";
import { sortVariantByCreationDate } from "../../utils";
import { TEXTS } from "../constants";
import styles from "../TiVoAppDetailsTabs.scss";
import { DetailsTabProps } from "../types";

export function TiVoAppDetailsVariantsTab({ provider }: DetailsTabProps) {
  const renderTableBody = () => {
    const variants = provider.variants || [];
    if (variants.length === 0) {
      return <TableNoResults />;
    }
    return (
      <TableBody className={styles.variantsTable}>
        {variants.sort(sortVariantByCreationDate).map((variant) => (
          <TiVoAppSubRow
            key={variant.id}
            provider={provider}
            variant={variant}
          />
        ))}
      </TableBody>
    );
  };

  return (
    <>
      <RestrictedArea allowed={[ROLES.tivo.provider]} showFallback={false}>
        <Button
          className={styles.editButton}
          to={pathToUrl(PATHS.createVariant, { id: provider.id, tabId: "" })}
          type="green"
          dataTestId="add-new-variant-button"
        >
          {TEXTS.VARIANTS.ADD_NEW_VARIANT_BUTTON}
        </Button>
      </RestrictedArea>
      <Section header={TEXTS.VARIANTS.HEADER}>
        <Table>
          <TableHeader>
            <TableHeaderColumn className={styles.variantNameCol}>
              {TEXTS.VARIANT.NAME_COL_HEADER}
            </TableHeaderColumn>
            <TableHeaderColumn className={styles.variantDateCol}>
              {TEXTS.VARIANTS.CREATION_DATE_COL_HEADER}
            </TableHeaderColumn>
            <TableHeaderColumn className={styles.variantStatusCol}>
              {TEXTS.VARIANTS.STATUS_COL_HEADER}
            </TableHeaderColumn>
            <TableHeaderColumn
              className={styles.variantActionCol}
            ></TableHeaderColumn>
          </TableHeader>
          {renderTableBody()}
        </Table>
      </Section>
    </>
  );
}
